import React, { useState, useEffect } from 'react';
import { getPedidos, exportarReporte, eliminarPedido } from '../../services/api';
import * as XLSX from 'xlsx';

function Pedidos() {
  const [pedidos, setPedidos] = useState([]);
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [estadoFiltro, setEstadoFiltro] = useState('');
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  useEffect(() => {
    // Por defecto mostrar pedidos de mañana
    const mañana = new Date();
    mañana.setDate(mañana.getDate() + 1);
    const fechaMañana = mañana.toISOString().split('T')[0];
    setFechaInicio(fechaMañana);
    setFechaFin(fechaMañana);
  }, []);

  useEffect(() => {
    if (fechaInicio && fechaFin) {
      cargarPedidos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fechaInicio, fechaFin, estadoFiltro]);

  const cargarPedidos = async () => {
    setLoading(true);
    try {
      const params = {};
      if (fechaInicio) params.fechaInicio = fechaInicio;
      if (fechaFin) params.fechaFin = fechaFin;
      if (estadoFiltro) params.estado = estadoFiltro;

      const response = await getPedidos(params);
      setPedidos(response.data);
    } catch (error) {
      console.error('Error cargando pedidos:', error);
    } finally {
      setLoading(false);
    }
  };

  const mostrarMensaje = (texto, tipo) => {
    setMensaje({ texto, tipo });
    setTimeout(() => setMensaje(null), 5000);
  };

  const handleEliminar = async (pedidoId, pedidoNum) => {
    if (
      !window.confirm(
        `¿Estás seguro de que quieres eliminar el pedido #${pedidoNum}? Esta acción no se puede deshacer.`
      )
    ) {
      return;
    }

    try {
      await eliminarPedido(pedidoId);
      mostrarMensaje('Pedido eliminado exitosamente', 'success');
      cargarPedidos();
    } catch (error) {
      console.error('Error eliminando pedido:', error);
      mostrarMensaje(
        error.response?.data?.error || 'Error al eliminar el pedido',
        'error'
      );
    }
  };

  const generarListadoFirmas = () => {
    if (!pedidos || pedidos.length === 0) {
      alert('No hay pedidos para generar el listado de firmas');
      return;
    }

    // Filtrar solo pedidos confirmados
    const pedidosConfirmados = pedidos.filter(p => p.estado === 'confirmado');
    
    if (pedidosConfirmados.length === 0) {
      alert('No hay pedidos confirmados para generar el listado');
      return;
    }

    // Ordenar por nombre
    const pedidosOrdenados = [...pedidosConfirmados].sort((a, b) => 
      a.usuario.nombre.localeCompare(b.usuario.nombre)
    );

    // Crear ventana de impresión
    const ventana = window.open('', '_blank');
    ventana.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Listado de Firmas - Retiro de Pedidos</title>
          <style>
            @media print {
              @page { margin: 1cm; }
              body { margin: 0; }
            }
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            .header {
              text-align: center;
              margin-bottom: 30px;
              border-bottom: 2px solid #27ae60;
              padding-bottom: 15px;
            }
            .header h1 {
              margin: 0;
              color: #27ae60;
              font-size: 24px;
            }
            .header p {
              margin: 5px 0;
              color: #666;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th {
              background-color: #27ae60;
              color: white;
              padding: 12px;
              text-align: left;
              font-weight: bold;
            }
            td {
              padding: 15px 12px;
              border-bottom: 1px solid #ddd;
            }
            tr:hover {
              background-color: #f5f5f5;
            }
            .firma-col {
              width: 200px;
              border-bottom: 1px solid #333;
              min-height: 40px;
            }
            .footer {
              margin-top: 30px;
              text-align: center;
              font-size: 12px;
              color: #999;
            }
            .total {
              margin-top: 20px;
              font-weight: bold;
              font-size: 16px;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>📋 LISTADO DE FIRMAS - RETIRO DE PEDIDOS</h1>
            <p><strong>Fecha:</strong> ${new Date(fechaInicio).toLocaleDateString('es-AR')} ${fechaInicio !== fechaFin ? ' a ' + new Date(fechaFin).toLocaleDateString('es-AR') : ''}</p>
            <p><strong>Generado:</strong> ${new Date().toLocaleString('es-AR')}</p>
          </div>
          
          <table>
            <thead>
              <tr>
                <th style="width: 40px;">#</th>
                <th>Nombre Completo</th>
                <th style="width: 100px;">DNI</th>
                <th style="width: 150px;">Sector</th>
                <th style="width: 120px;">Fecha Pedido</th>
                <th style="width: 180px;">Firma</th>
              </tr>
            </thead>
            <tbody>
              ${pedidosOrdenados.map((pedido, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${pedido.usuario.nombre}</td>
                  <td>${pedido.usuario.dni || 'N/A'}</td>
                  <td>${pedido.usuario.sector || 'N/A'}</td>
                  <td>${new Date(pedido.fecha).toLocaleDateString('es-AR')}</td>
                  <td class="firma-col"></td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          
          <div class="total">
            Total de pedidos: ${pedidosOrdenados.length}
          </div>
          
          <div class="footer">
            <p>Sistema de Gestión de Viandas - MealPoint</p>
          </div>
          
          <script>
            window.onload = function() {
              window.print();
            };
          </script>
        </body>
      </html>
    `);
    ventana.document.close();
  };

  const descargarReporte = async () => {
    if (!fechaInicio || !fechaFin) {
      alert('Selecciona un rango de fechas primero');
      return;
    }

    try {
      const response = await exportarReporte(fechaInicio, fechaFin);
      const data = response.data;
      
      console.log('Datos recibidos:', data);

      if (!data.pedidos || data.pedidos.length === 0) {
        alert('No hay pedidos para exportar en este rango de fechas');
        return;
      }

      // Mapa de colores por categoría
      const coloresCategorias = {
        'Entrada': 'E8F5E9',      // Verde claro
        'Principal': 'FFF3E0',    // Naranja claro
        'Postre': 'F3E5F5',       // Púrpura claro
        'Bebida': 'E3F2FD'        // Azul claro
      };

      // Agrupar platos por categoría
      const platosPorCategoria = {};
      data.platos.forEach((plato) => {
        if (!platosPorCategoria[plato.categoria]) {
          platosPorCategoria[plato.categoria] = [];
        }
        platosPorCategoria[plato.categoria].push(plato);
      });

      // Crear orden de categorías
      const ordenCategorias = ['Entrada', 'Principal', 'Postre', 'Bebida'];
      const categoriasOrdenadas = ordenCategorias.filter(c => platosPorCategoria[c]);

      // Crear cabeceras
      const encabezados = ['DNI', 'Nombre', 'Tipo Usuario'];
      
      // Agregar platos en orden
      categoriasOrdenadas.forEach((categoria) => {
        platosPorCategoria[categoria].forEach((plato) => {
          encabezados.push(plato.nombre);
        });
      });

      // Preparar datos para Excel
      const datosExcel = data.pedidos.map((p) => {
        const fila = {
          DNI: p.dni,
          Nombre: `${p.nombre} ${p.apellido}`,
          'Tipo Usuario': p.tipo_usuario
        };

        // Llenar con los platos
        categoriasOrdenadas.forEach((categoria) => {
          platosPorCategoria[categoria].forEach((plato) => {
            fila[plato.nombre] = p.platos[plato.id] ? '✓' : '';
          });
        });

        return fila;
      });

      // Crear workbook
      const ws = XLSX.utils.json_to_sheet(datosExcel);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Pedidos');

      // Configurar ancho de columnas
      const colWidths = [
        { wch: 12 }, // DNI
        { wch: 25 }, // Nombre
        { wch: 15 }  // Tipo Usuario
      ];
      categoriasOrdenadas.forEach((categoria) => {
        platosPorCategoria[categoria].forEach(() => {
          colWidths.push({ wch: 18 });
        });
      });
      ws['!cols'] = colWidths;

      // Formatear celdas
      const range = XLSX.utils.decode_range(ws['!ref']);
      
      // Formatear encabezados
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const address = XLSX.utils.encode_col(C) + '1';
        if (!ws[address]) continue;
        
        ws[address].s = {
          font: { bold: true, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '2C3E50' } },
          alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
          border: {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' }
          }
        };
      }

      // Formatear datos
      for (let R = range.s.r + 1; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const address = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[address]) continue;
          
          // Obtener el nombre de la columna
          const colName = encabezados[C];
          let backgroundColor = 'FFFFFF';
          
          // Asignar color según categoría
          categoriasOrdenadas.forEach((categoria) => {
            if (platosPorCategoria[categoria].some(p => p.nombre === colName)) {
              backgroundColor = coloresCategorias[categoria];
            }
          });

          ws[address].s = {
            border: {
              top: { style: 'thin' },
              bottom: { style: 'thin' },
              left: { style: 'thin' },
              right: { style: 'thin' }
            },
            fill: { fgColor: { rgb: backgroundColor } },
            alignment: { horizontal: 'center', vertical: 'center' }
          };
        }
      }

      // Descargar
      XLSX.writeFile(wb, `pedidos_${fechaInicio}_a_${fechaFin}.xlsx`);
    } catch (error) {
      console.error('Error descargando reporte:', error);
      alert('Error al descargar el reporte');
    }
  };

  return (
    <div>
      <div className="page-header">
        <h1>Pedidos</h1>
        <p>Visualiza y administra todos los pedidos</p>
      </div>

      {mensaje && (
        <div className={`alert alert-${mensaje.tipo}`}>{mensaje.texto}</div>
      )}

      <div className="card">
        <div
          style={{
            display: 'flex',
            gap: '15px',
            marginBottom: '20px',
            alignItems: 'flex-end',
          }}
        >
          <div className="form-group" style={{ flex: 1, marginBottom: 0 }}>
            <label>Fecha Inicio</label>
            <input
              type="date"
              className="form-control"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
            />
          </div>

          <div className="form-group" style={{ flex: 1, marginBottom: 0 }}>
            <label>Fecha Fin</label>
            <input
              type="date"
              className="form-control"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
            />
          </div>

          <div className="form-group" style={{ flex: 1.5, marginBottom: 0 }}>
            <label>Estado</label>
            <select
              className="form-control"
              value={estadoFiltro}
              onChange={(e) => setEstadoFiltro(e.target.value)}
            >
              <option value="">Todos</option>
              <option value="confirmado">Confirmado</option>
              <option value="cancelado">Cancelado</option>
              <option value="entregado">Entregado</option>
            </select>
          </div>

          <button className="btn btn-success" onClick={descargarReporte}>
            📊 Descargar Reporte
          </button>
          
          <button 
            className="btn btn-primary" 
            onClick={generarListadoFirmas}
            style={{ background: '#3498db' }}
          >
            ✍️ Listado de Firmas
          </button>
        </div>

        {loading ? (
          <div className="loading">Cargando pedidos...</div>
        ) : (
          <>
            <div style={{ marginBottom: '15px' }}>
              <strong>Total de pedidos: {pedidos.length}</strong>
            </div>

            {pedidos.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#7f8c8d', padding: '40px' }}>
                No hay pedidos para los filtros seleccionados
              </p>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Usuario</th>
                    <th>DNI</th>
                    <th>Tipo</th>
                    <th>Fecha Pedido</th>
                    <th>Interfaz</th>
                    <th>Estado</th>
                    <th>Items</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {pedidos.map((pedido) => (
                    <tr key={pedido.id}>
                      <td>{pedido.id}</td>
                      <td>{pedido.usuario.nombre}</td>
                      <td>{pedido.usuario.dni}</td>
                      <td>
                        <span
                          style={{
                            fontSize: '12px',
                            padding: '3px 8px',
                            borderRadius: '3px',
                            background:
                              pedido.usuario.tipo === 'operario'
                                ? '#3498db'
                                : '#27ae60',
                            color: 'white',
                          }}
                        >
                          {pedido.usuario.tipo}
                        </span>
                      </td>
                      <td>{new Date(pedido.fecha).toLocaleDateString('es-AR')}</td>
                      <td>
                        <span
                          style={{
                            fontSize: '12px',
                            padding: '3px 8px',
                            borderRadius: '3px',
                            background:
                              pedido.tipoInterfaz === 'totem' ? '#9b59b6' : '#34495e',
                            color: 'white',
                          }}
                        >
                          {pedido.tipoInterfaz}
                        </span>
                      </td>
                      <td>
                        <span
                          style={{
                            fontSize: '12px',
                            padding: '3px 8px',
                            borderRadius: '3px',
                            background:
                              pedido.estado === 'confirmado'
                                ? '#27ae60'
                                : pedido.estado === 'cancelado'
                                ? '#e74c3c'
                                : '#95a5a6',
                            color: 'white',
                          }}
                        >
                          {pedido.estado}
                        </span>
                      </td>
                      <td>
                        <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px' }}>
                          {pedido.items.map((item, idx) => (
                            <li key={idx}>
                              {item.categoria}: {item.plato}
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td>
                        <button
                          className="btn btn-danger"
                          onClick={() => handleEliminar(pedido.id, pedido.id)}
                          style={{
                            fontSize: '12px',
                            padding: '5px 10px',
                          }}
                        >
                          🗑️ Eliminar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Pedidos;
